import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Backdrop from "../components/common/Backdrop";
import Image from "../components/common/Image";
import { useGetRankInfoQuery } from "../features/api/userApiSlice";
import { useTranslation } from "react-i18next";
import * as Constant from "../features/constant";

const Vip = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const lang = localStorage.getItem("language");

  const {
    data: rankInfo,
    isFetching: isRankInfoFetching,
    isLoading: isRankInfoLoading,
    isError: isRankInfoError,
    isSuccess: isRankInfoSuccess,
    error: rankInfoError,
  } = useGetRankInfoQuery({ prefetch: true });

  return (
    <>
      {(isRankInfoLoading || isRankInfoFetching) && <Backdrop />}
      {!isRankInfoLoading && isRankInfoSuccess && (
        <Box
          sx={{
            pt: mobileView ? "55px" : "0",
            // background: `url('${rankInfo?.webBackground[0]?.thumbnailUrl}')`,
            backgroundColor: theme.palette.background.home,
          }}
        >
          {(
            // Show if NOT mobile
            !mobileView ||
            // Or if mobile AND env variable is NOT "false"
            process.env.REACT_APP_VIP_BANNER_MOBILE !== "false"
          ) && (
            <Image
              src={
                lang === "en" || lang === null
                  ? process.env.REACT_APP_VIP_BANNER_EN
                  : process.env.REACT_APP_VIP_BANNER_BD
              }
            />
          )}
          {process.env.REACT_APP_VIP_IMG_CONTENT === 'true' ? (
            !mobileView ? (
              <Image
                src={
                  lang === 'en' || lang === null
                    ? process.env.REACT_APP_VIP_CONTENT_EN
                    : process.env.REACT_APP_VIP_CONTENT_BD
                }
              />
            ) : (
              <Box
                sx={{
                  width: '100%',
                  overflow: 'auto',
                  display: 'flex',
                }}
              >
                <Image
                  sx={{
                    minWidth: '200%',
                    height: 'auto',
                    display: 'block',
                  }}
                  src={
                    lang === 'en' || lang === null
                      ? process.env.REACT_APP_VIP_MOBILE_CONTENT_EN
                      : process.env.REACT_APP_VIP_MOBILE_CONTENT_MY
                  }
                />
              </Box>
            )
          ) : (

          <Container>
            <Box py={{ xs: 3, sm: 3, lg: 3, xl: 3 }}>
              {/* <Typography
                variant="h4"
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
                color="white"
              >
                {t("home.vip.title")}{" "}
              </Typography> */}
              <Box pb={4} pt={1}>
                <TableContainer component={Paper}>
                  <Table aria-label="VIP table" sx={{
                    '& .MuiTableCell-sizeMedium': {
                    padding: '8px',
                  }}}>
                    <TableHead>
                      <TableRow sx={{
                          background: theme.palette.primary.main,
                          border: "none"
                        }}>
                        <TableCell sx={{ border: "none" }}>
                          <Typography color="white" align="center" sx={{ fontWeight: "bold" }}>
                            {t("home.vip.privileges")}
                          </Typography>
                        </TableCell>
                        {Object.keys(rankInfo?.result?.rankDetails).map(
                          (rankDetail, idx) => (
                            <TableCell key={idx} align="center" sx={{ border: "none" }}>
                              <Box
                                component="div"
                                display="inline-block"
                                sx={{ textAlign: "center" }}
                              >
                                <Typography sx={{ fontWeight: "bold" }} color="white">
                                  {rankDetail}
                                </Typography>
                              </Box>
                            </TableCell>
                          )
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.keys(rankInfo?.result?.privileges).map(
                        (privilege, idx) => (
                          <>
                            <TableRow 
                              key={idx} 
                              sx={{ 
                                background: 
                                  idx % 2 == 1 
                                    ? process.env.REACT_APP_COLOR_VIP_TABLE1 || theme.palette.background.paper
                                    : process.env.REACT_APP_COLOR_VIP_TABLE2 || theme.palette.background.secondaryPaper, 
                              }}
                            >
                              <TableCell component="th" scope="row" sx={{ border: "none" }}>
                                <Box display="flex" alignItems="center" pl={0}>
                                  {rankInfo?.result?.privileges[privilege].logo && <Image
                                    src={
                                      rankInfo?.result?.privileges[privilege].logo
                                    }
                                    height="25px"
                                    width="25px"
                                    alt={Constant.ALT_TAG_VIP + privilege}
                                  />}
                                  <Typography
                                    sx={{
                                      color: "white",
                                      textTransform: "uppercase"
                                    }}
                                    ml="3px"
                                  >
                                    {privilege}
                                  </Typography>
                                </Box>
                              </TableCell>
                              {Object.keys(rankInfo?.result?.rankDetails).map((detail, idx) => (
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="center"
                                    sx={{ fontWeight: "normal", color: "white", border: "none" }}>
                                    {rankInfo?.result?.rankDetails[detail][privilege]}
                                  </TableCell>
                              ))}
                            </TableRow>
                          </>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Container>
          )}
        </Box>
      )}
    </>
  );
};

export default Vip;
